export const footerServices = [
  'Custom AI Solutions Development',
  'Information Systems Development (ISD)',
  'Apps Development',
  'AI Integration & API Development',
  'Digital Systems Training',
];
